<template lang="pug">
div
  el-row
    el-col(:span="24")
      app-resumo-cadastrante(:cadastrante="cadastro.cadastrante" :isProcessoFisico="true")
      app-resumo-interessado(
        :interessado="cadastro.interessado",
        :hasConjuge="true"
        :idCadastro="idCadastro",
        :isLiberacao="false"
        :isProcessoFisico="true"
      )
      resumo-imovel(
        v-if="cadastro"
        :imovel="cadastro.imovel"
        :idCadastro="idCadastro"
        :hasFieldsExtras="false"
        :isProcessoFisico="true"
      )

</template>
<script>
import AppResumoCadastrante from '@/components/resumo/AppResumoCadastrante'
import AppResumoInteressado from '@/components/resumo/AppResumoInteressado'
import AppResumoImovel from '@/components/resumo/AppResumoImovel'
import ResumoImovel from './ResumoImovel.vue'

import AppButton from '@/components/shared/AppButton'

export default {
  components: {
    AppButton,
    AppResumoCadastrante,
    AppResumoInteressado,
    AppResumoImovel,
    ResumoImovel
  },

  props: ['cadastro', 'idCadastro']
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/maranhao/processoFisico/components/Resumo.vue